module.exports = __webpack_public_path__ + "img/Stackly_Code.6664ae54.jpg";